import React from 'react';
import { InfoWarning } from 'scy/Warning';
import { textClasses } from 'components/ui/text';
import { viewClasses } from 'components/ui/view';
import InfoIcon from 'components/ui/icons/info';

export default function CheckoutPageLegalBox({ display_text, links, info }) {
  const html = insertLinks(display_text, links);
  return (
    <InfoWarning>
      {!!info && (
        <a href={info} className={`right ${viewClasses({ padding: 'xxs' })}`}>
          <InfoIcon
            className={textClasses({ secondary: true, weight: 'bold' })}
          />
        </a>
      )}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </InfoWarning>
  );
}

function insertLinks(display_text, links = []) {
  let output = display_text || '';
  links.forEach(({ string, url }) => {
    if (!string || !url) return;
    const pattern = new RegExp(string, 'g');
    output = output.replace(
      pattern,
      `<a class="link-text" href="${url}">${string}</a>`
    );
  });
  return output;
}
